import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_GSC_LISTING_URL } from '../../constants/apiUrls';
import { ApiPathParam } from '../../models/SearchParamSchema';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PageDataSort {
  direction: boolean;
  property: string;
  ignoreCase: boolean;
  nullHandling: string;
  ascending: boolean;
  descending: boolean;
}

export interface Pageable {
  sort: PageDataSort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  unpaged: boolean;
  paged: boolean;
}

export interface PageDataContent {
  uuid: string;
  applicationId: string;
  examLevel: string;
  applicationDate: string;
  applcationStatus: string;
  applicationClosed: boolean;
  amendmentDraft: boolean;
  groupScType: string;
  candidateName: string | null;
  candidateId: string | null;
  lastUpdateDatetime: string | null;
}

export interface PageData {
  content: PageDataContent[];
  pageable: Pageable;
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: PageDataSort[];
  empty: boolean;
}

export interface GroupSCListingResponse {
  pageData: PageData;
  errorMsg: string;
  canApplication: boolean;
}

export interface GroupSCListingRequest {
  q?: string;
  pathParams: ApiPathParam;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: GroupSCListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostGroupSCListing = ({ onSuccess, onError }: Input) => {
  const postGroupSCListing = async (payload: GroupSCListingRequest) => {
    const res = await axiosClient.post<GroupSCListingResponse>(
      POST_GSC_LISTING_URL(payload.pathParams),
      {
        q: payload.q,
      }
    );
    return res.data;
  };

  return useCustomMutation(postGroupSCListing, {
    onSuccess,
    onError,
  });
};
